import * as Cookies from "js-cookie";
import { Common } from "./global/common";
import { DateTime } from "./global/date-time";
import { Lazy } from "./global/lazy/_lazy";
import { UserInterface } from "./global/user-interface";

export class App {
    static readonly Common = Common;
    static readonly Lazy = Lazy;
    static readonly UserInterface = UserInterface;
    static readonly DateTime = DateTime;

    static loginSessionAboutToExpireTimer: number;

    static get currentLanguage(): string { return document.documentElement.getAttribute("data-currentLanguage"); }
    static get loginSessionAboutToExpireSeconds(): number { return Number(document.getElementById("body").getAttribute("data-loginSessionAboutToExpireSeconds")); }
    static set loginSessionAboutToExpireSeconds(seconds: number) { document.getElementById("body").setAttribute("data-loginSessionAboutToExpireSeconds", seconds.toString()); }
    static displayWarningOnUnload = true;
    static inputChanged = false;

    static isCiamSet: boolean;
    static isCiam: boolean;
    static isAnonymous: boolean;
    static allowAspNetSessionIsAboutToExpireDialog: boolean;

    static validator: JQueryValidation.Validator = null;

    static init(autocreation = false): void {
        const body = document.getElementById("body");
        const ciamFlag = body.getAttribute("data-is-ciam");
        App.isCiamSet = ciamFlag != null;
        App.isCiam = ciamFlag == "true";
        App.isAnonymous = body.getAttribute("data-is-anonymous") == "true";
        App.allowAspNetSessionIsAboutToExpireDialog = body.getAttribute("data-allow-asp-net-session-is-about-to-expire-dialog") == "true";

        window.addEventListener("error", (event) => {
            setTimeout(() => { App.Common.Logging.logErrorEvent(event); }, 1);
        });

        /* Show forms only if JS is activated */
        const noJsItems = document.getElementsByClassName("nojs") as HTMLCollectionOf<HTMLDivElement>;
        Array.from(noJsItems).forEach(item => {
            item.classList.remove("nojs");
        });

        // eslint-disable-next-line
        (window as any).App = App;

        App.DateTime.init();
        App.Common.init();
        App.UserInterface.init();
        if (!autocreation) {
            App.Lazy.init();
        }

        //for this log is an antiForgeryToken required. this is not available at this point. either move token before scripts or use some kind of event
        App.Common.Logging.logDebug("App initialized");
    }

    static setEpsLanguageCookieIfNotExists() {
        if (!Cookies.get("epslanguage")) {
            const selectedLanguageCode = $("html").attr("lang");
            App.setEpsLanguageCookie(selectedLanguageCode);
        }
    }

    static setEpsLanguageCookie(languageCode: string) {
        Cookies.set("epslanguage", languageCode, { expires: 365, secure: true, sameSite: "lax" });
    }

    static saveLangInSession(link: HTMLAnchorElement | JQuery<HTMLElement>) {
        const langCode = $(link).data("langcode");
        App.setEpsLanguageCookie(langCode);
    }

    static setLoginSessionAboutToExpireTimer() {
        if (App.loginSessionAboutToExpireTimer) {
            clearTimeout(App.loginSessionAboutToExpireTimer);
        }
        if (App.loginSessionAboutToExpireSeconds) {
            App.loginSessionAboutToExpireTimer = window.setTimeout(() => { App.Common.Dialogs.openModalSessionAboutToExpire(document.getElementById("sessionIsAboutToExpireDialog")) }, App.loginSessionAboutToExpireSeconds * 1000);
        }
    }
}